import MaterialBox from "../../../../../components/MaterialBox";
import { Box, Card, Grid, Stack } from "@mui/material";
import MaterialTypography from "../../../../../components/MaterialTypography";
import MaterialInput from "../../../../../components/MaterialInput";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
const SecondComponent = ({ meetingData, pages, setMeetingData }) => {
  const [update, setUpdate] = useState(false);
  const [index, setIndex] = useState();
  // Add point to summary
  const handleSubmit = () => {
    const pointsAdd = [...(meetingData?.summary || [])];
    if (update) {
      pointsAdd[index] = meetingData?.points;
    } else {
      pointsAdd.push(meetingData?.points);
    }

    setMeetingData((prev) => ({
      ...prev,
      summary: pointsAdd,
      points: "",
    }));
  };

  // Delete point from summary
  const handleDelete = (index) => {
    const updated = [...(meetingData?.summary || [])];
    updated.splice(index, 1);
    setMeetingData((prev) => ({
      ...prev,
      summary: updated,
    }));
  };

  const handleEdit = (index) => {
    const itemToEdit = meetingData?.summary[index];

    setMeetingData((pre) => ({
      ...pre,
      points: itemToEdit,
    }));
    setUpdate(true);
    setIndex(index);
  };

  return (
    <div>
      <MaterialBox sx={{ p: 2 }}>
        <Box style={{ borderRadius: "5px", hight: "700px", padding: "5px" }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Add Summary Of Discussion <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <Box style={{ display: "flex" }}>
              <MaterialInput
                size="small"
                multiline
                rows={2}
                name="meetingAganta"
                placeholder="Summary Of Discussion"
                value={meetingData?.points}
                onChange={(e) =>
                  setMeetingData((prev) => ({
                    ...prev,
                    points: e.target.value,
                  }))
                }
                disabled={pages.view}
              />
              <button
                style={{
                  backgroundColor: "green",
                  border: "none",
                  borderRadius: "10%",
                  width: "50px",
                  height: "50px",
                  color: "white",
                  margin: "5px",
                  cursor: "pointer",
                }}
                disabled={pages.view}
                onClick={() => handleSubmit()}
              >
                {/* <div style={{ fontSize: "20px" }}>
                  <AddIcon />
                </div> */}
                Add
              </button>
            </Box>
          </Stack>
          <Grid container spacing={1} sx={{ margin: "15px 0px" }}>
            {meetingData?.summary.map((item, ind) => (
              <Grid size={{ xs: 12, md: 12 }}>
                <Card sx={{ padding: "10px", backgroundColor: "#fff", border: "1px dotted #93bcfbff", borderRadius: "5px" }}>
                  <div
                    key={ind}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                      marginBottom: "10px",
                      wordBreak: "break-word",
                      width: "100%",
                    }}
                  >
                    <DeleteIcon
                      style={{
                        color: "red",
                        cursor: "pointer",
                        marginTop: "3px",
                      }}
                      onClick={() => handleDelete(ind)}
                      titleAccess="Delete"
                      disabled={pages?.view}
                    />
                    <ModeEditIcon
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        marginTop: "3px",
                      }}
                      disabled={pages?.view}
                      onClick={() => handleEdit(ind)}
                      titleAccess="Edit"
                    />
                    <p
                      style={{
                        fontSize: "15px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        flex: 1,
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>{ind + 1}. </span>
                      {item}
                    </p>
                  </div>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </MaterialBox>
    </div>
  );
};

export default SecondComponent;
